// M33 — Tiny legal-links + version strip rendered below the auth-page
// cards (login, register, forgot-password, reset-password). One place
// to change the link order or styling for all four pages.
//
// Deliberately compact: caption-sized text in `text.secondary`, three
// items separated by middots. Doesn't compete with the auth form for
// visual weight but is always visible without scrolling.

import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function AuthPageFooter() {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.25,
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        color: 'text.secondary',
      }}
    >
      <Link
        component={RouterLink}
        to="/privacy"
        variant="caption"
        color="inherit"
        underline="hover"
      >
        Privacy
      </Link>
      <Typography variant="caption" aria-hidden>·</Typography>
      <Link
        component={RouterLink}
        to="/terms"
        variant="caption"
        color="inherit"
        underline="hover"
      >
        Terms
      </Link>
      <Typography variant="caption" aria-hidden>·</Typography>
      <Typography
        variant="caption"
        sx={{ fontFamily: 'monospace' }}
      >
        v{__APP_VERSION__}
      </Typography>
    </Box>
  );
}
